import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import CustomTabs from '../../ui-parts/CustomTabs';
import MetadataApliableFilterCard from '../../ui-parts/MetadataApliableFilterCard';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { ServiceLv2SubLv2DocumentsTabContents } from './ServiceLv2SubLv2DocumentsTabContents';
import { ServiceLv2SubLv2PreparationTabContents } from './ServiceLv2SubLv2PreparationTabContents';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { Box, Drawer, IconButton} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';

/** MyMine Version2.0 ServiceLv2_2画面新規追加
 * ServiceLv2_2 Page Component
 */
const ServiceLv2SubLv2 = () => {

  const screenId = 'MyM321';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const navigate = useNavigate();
  const [apliableFilterList, setApliableFilterList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [previewFileId, setPreviewFileId] = useState(null);
  const handleModalClose = () => setPreviewFileId(null);
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isOpenFilterMenu, setIsFilterMenu] = useState(false);

  function openFilterMenu() { setIsFilterMenu(true); }
  function closeFilterMenu() { setIsFilterMenu(false); }

  useEffect(() => {

    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestServiceContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestServiceContents();
        return;
      }

      setContent(result);
      setIsLoading(false);
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestServiceContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson(`api/service/lv2-2`, 'GET', callbackSuccessRequestServiceContents, callbackFailedRequestServiceContents)
  }, []);

  /** フィルタ適用時 */
  useEffect(() => {
    if (content == null) { return; }

    /**
     * 一覧ページ取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSuccessedFilterSearch = (result) => {
      setContent({ ...content, PreDeliveryMetadataList: result });
      setIsLoading(false);
    }

    /**
     * 一覧ページ取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackFailedFilterSearch = (result) => {
      setIsLoading(false);
    }

    const paramObj = {
      FilterMetadataIds: apliableFilterList.join(',')
    };
    setIsLoading(true);

    apiRequest.requestJson(`api/service/pre-delivery-file?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSuccessedFilterSearch, callbackFailedFilterSearch);

  }, [apliableFilterList]);

  /**
* お気に入りコールバック処理
* @param {number} favoriteFileId お気に入りファイルID
*/
  const callbackFavorite = (favoriteFileId) => {
    // Stateのお気に入り情報を更新
    content.PreDeliveryMetadataList.forEach(thirdCategory => {
      thirdCategory.BoxFileList.forEach(stateBoxFile => {
        if (stateBoxFile.FileId === favoriteFileId) {
          stateBoxFile.IsFavorite = !stateBoxFile.IsFavorite;
        }
      })
    })
  }

  if (content == null)
    return <MyMProgress />

  return (
    <Box className='py-2 d-flex flex-column'>
      {isLoading && <MyMProgress />}
      {!isPc && 
        <>
          <IconButton
            color="inherit"
            className='p-0'
            onMouseEnter={openFilterMenu}
          >
          <FilterAltIcon sx={{ fontSize: '35px', position: 'relative', right:'-40%' }} />
          </IconButton>
          <Drawer sx={{ '& .MuiDrawer-paper': { maxHeight: '800px', top: 30 } }} anchor="left" open={isOpenFilterMenu} onClose={closeFilterMenu} >
          <Box>
            <IconButton onClick={closeFilterMenu} style={{ position: 'absolute', right: 0, top: 0 }}>
              <CloseIcon sx={{ fontSize: '30px' }} />
            </IconButton>
            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultsByTitle}
              metadataList={content.FilterList}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
            </Box>
          </Drawer>
        </>
      }

      <Grid container columnSpacing={1}>
        <Grid item xs={12} lg={9}>
          <Box className='d-flex flex-column h-100 m-auto' sx={{ maxWidth: 1300, backgroundColor: '#777777', borderRadius: '10px' }}>
            <CustomTabs
              isArrowTab={true}
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={setSelectedTabIndex}
              isPc={isPc}
              tabCaptionList={
                content.PreDeliveryMetadataList.map((x, i) => {
                  return {
                    id: i,
                    caption:
                      <div>
                        <span className='text-capitalize'>{x.MetadataName}</span>
                        <div className="arrow"></div>
                        <div className="active-arrow"></div>
                      </div>,
                  }
                })
              }
              tabContents=
              {
                <Box sx={{ flex: 1, backgroundColor: '#ffffff', border: '2px solid grey', borderRadius: '0px 0px 10px 10px' }}>
                  {content.PreDeliveryMetadataList.map((metadata, i) => {
                    return i === 0
                      ?
                      <ServiceLv2SubLv2PreparationTabContents
                        key={i}
                        visible={i === selectedTabIndex}
                        screenId={screenId}
                        metadata={metadata}
                        isPc={isPc}
                      />
                      :
                      <ServiceLv2SubLv2DocumentsTabContents
                        key={i}
                        visible={i === selectedTabIndex}
                        screenId={screenId}
                        callbackFavorite={callbackFavorite}
                        metadata={metadata}
                        setIsLoading={setIsLoading}
                        isPc={isPc}
                      />
                  })}
                </Box>
              }
            />
          </Box>
        </Grid>
        {isPc &&
          <Grid item xs={12} lg={3}>
            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultsByTitle}
              metadataList={content.FilterList}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </Grid>
        }
      </Grid>
      <MyMModal
        open={previewFileId !== null}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Box>
  );
}
export default ServiceLv2SubLv2;
